/**
 * @flow
 * @relayHash 7413fb4b0f2839907590d48371eafe4a
 */

/* eslint-disable */

'use strict'

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AppManagementCreateThemeInput = {|
  name: string,
  startAt?: ?any,
  finishAt?: ?any,
  clientMutationId?: ?string,
|};
export type WebsiteContainerCreateThemeMutationVariables = {|
  input: AppManagementCreateThemeInput
|};
export type WebsiteContainerCreateThemeMutationResponse = {|
  +appManagementCreateTheme: ?{|
    +success: ?boolean,
    +theme: ?{|
      +id: string,
      +name: string,
      +createdAt: ?any,
      +createdByUserCuid: ?string,
      +startAt: ?any,
      +finishAt: ?any,
    |},
    +errors: ?$ReadOnlyArray<?{|
      +statusCode: ?number,
      +message: ?string,
      +meta: ?any,
      +errorCode: ?string,
      +code: ?number,
    |}>,
  |}
|};
export type WebsiteContainerCreateThemeMutation = {|
  variables: WebsiteContainerCreateThemeMutationVariables,
  response: WebsiteContainerCreateThemeMutationResponse,
|};
*/

/*
mutation WebsiteContainerCreateThemeMutation(
  $input: AppManagementCreateThemeInput!
) {
  appManagementCreateTheme(input: $input) {
    success
    theme {
      id
      name
      createdAt
      createdByUserCuid
      startAt
      finishAt
    }
    errors {
      statusCode
      message
      meta
      errorCode
      code
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
    var v0 = [
            {
                kind: 'LocalArgument',
                name: 'input',
                type: 'AppManagementCreateThemeInput!',
                defaultValue: null,
            },
        ],
        v1 = [
            {
                kind: 'LinkedField',
                alias: null,
                name: 'appManagementCreateTheme',
                storageKey: null,
                args: [
                    {
                        kind: 'Variable',
                        name: 'input',
                        variableName: 'input',
                    },
                ],
                concreteType: 'AppManagementCreateThemePayload',
                plural: false,
                selections: [
                    {
                        kind: 'ScalarField',
                        alias: null,
                        name: 'success',
                        args: null,
                        storageKey: null,
                    },
                    {
                        kind: 'LinkedField',
                        alias: null,
                        name: 'theme',
                        storageKey: null,
                        args: null,
                        concreteType: 'AppManagementTheme',
                        plural: false,
                        selections: [
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'id',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'name',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'createdAt',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'createdByUserCuid',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'startAt',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'finishAt',
                                args: null,
                                storageKey: null,
                            },
                        ],
                    },
                    {
                        kind: 'LinkedField',
                        alias: null,
                        name: 'errors',
                        storageKey: null,
                        args: null,
                        concreteType: 'AppManagementError',
                        plural: true,
                        selections: [
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'statusCode',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'message',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'meta',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'errorCode',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'code',
                                args: null,
                                storageKey: null,
                            },
                        ],
                    },
                ],
            },
        ]
    return {
        kind: 'Request',
        fragment: {
            kind: 'Fragment',
            name: 'WebsiteContainerCreateThemeMutation',
            type: 'Mutation',
            metadata: null,
            argumentDefinitions: (v0 /*: any*/),
            selections: (v1 /*: any*/),
        },
        operation: {
            kind: 'Operation',
            name: 'WebsiteContainerCreateThemeMutation',
            argumentDefinitions: (v0 /*: any*/),
            selections: (v1 /*: any*/),
        },
        params: {
            operationKind: 'mutation',
            name: 'WebsiteContainerCreateThemeMutation',
            id: null,
            text:
                'mutation WebsiteContainerCreateThemeMutation(\n  $input: AppManagementCreateThemeInput!\n) {\n  appManagementCreateTheme(input: $input) {\n    success\n    theme {\n      id\n      name\n      createdAt\n      createdByUserCuid\n      startAt\n      finishAt\n    }\n    errors {\n      statusCode\n      message\n      meta\n      errorCode\n      code\n    }\n  }\n}\n',
            metadata: {},
        },
    }
})()
// prettier-ignore
;(node/*: any*/).hash = 'ed3687440f96644ab504eb660c09f19d';
module.exports = node
